module.exports = __webpack_public_path__ + "kudos_76.svg?d37110ae4ca569de6ad9f90e8559681f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_76.svg
// module id = 179
// module chunks = 0